"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_firebase_1 = require("react-redux-firebase");
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var ServiceNameSelect_1 = __importDefault(require("atomicComponents/organisms/Autocomplete/ServiceNameSelect"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var Text_1 = __importDefault(require("shared/components/Text"));
var backend_1 = require("utils/backend");
var logging_1 = require("utils/logging");
var hooks_1 = require("./hooks");
var isStaging = window.location.host.match(/staging[.-]hudled/);
var isLocalhost = window.location.host.match(/localhost/);
// ToDo: use FinalForm to handle the form. Add an owner select that handles after the submission
var AddService = function (_a) {
    var _b;
    var companyId = _a.companyId;
    var firebaseInstance = (0, react_redux_firebase_1.useFirebase)();
    var allServices = (0, hooks_1.useGetAllServicesNames)();
    var services = (_b = allServices === null || allServices === void 0 ? void 0 : allServices.map(function (service) { return (service === null || service === void 0 ? void 0 : service.trim()); }).filter(Boolean)) !== null && _b !== void 0 ? _b : [];
    var uniqueServices = Array.from(new Set(services));
    uniqueServices.sort();
    var _c = __read((0, react_1.useState)(null), 2), validationMsg = _c[0], setValidationMsg = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isLoading = _d[0], setIsLoading = _d[1];
    var resetInput = function () {
        setIsLoading(false);
        setTimeout(function () {
            setValidationMsg(null);
        }, 5000);
    };
    var saveServiceStat = function (service) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedService, serviceQuerySnapshot, serviceDocID_1, newServiceDocRef, result, serviceStatDocRef, generateBy, expendituresTempl, serviceStatSeed, docRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setValidationMsg(null);
                    setIsLoading(true);
                    if (!(service && (service === null || service === void 0 ? void 0 : service.value))) return [3 /*break*/, 14];
                    selectedService = service.value;
                    return [4 /*yield*/, firebaseInstance.firestore().collection('services')
                            .where('name', '==', selectedService).get()];
                case 1:
                    serviceQuerySnapshot = _a.sent();
                    serviceDocID_1 = null;
                    if (!serviceQuerySnapshot.empty) return [3 /*break*/, 6];
                    return [4 /*yield*/, firebaseInstance.firestore().collection('services').add({
                            name: selectedService,
                            nicename: selectedService,
                            generateBy: 'manual',
                        })];
                case 2:
                    newServiceDocRef = _a.sent();
                    if (!newServiceDocRef) return [3 /*break*/, 5];
                    serviceDocID_1 = newServiceDocRef.id;
                    return [4 /*yield*/, (0, backend_1.callBackendFn)('service-notifyManualAdd', {
                            name: selectedService,
                            id: serviceDocID_1,
                            context: 'ADD_SERVICE_SERVICE_VIEW',
                            companyId: companyId,
                        })];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, fetch('https://api.apify.com/v2/acts/hudled~hudled-g2-scrape/runs?token=uL4sdN9fsSSJkGqKvnQHE2pn4', {
                            method: 'POST',
                            // credentials: 'include',
                            // mode: 'no-cors',
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                services: [
                                    {
                                        name: selectedService,
                                        id: serviceDocID_1,
                                    },
                                ],
                                env: (isStaging || isLocalhost) ? 'staging' : 'prod', // Set target Database for scraping result
                            }),
                        })];
                case 4:
                    result = _a.sent();
                    if (result.status === 201) {
                        (0, logging_1.logInfo)('Apify cloud scraping is starting');
                    }
                    resetInput();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    // If it exist, get the service doc ID
                    serviceQuerySnapshot.forEach(function (doc) {
                        serviceDocID_1 = doc.id;
                    });
                    _a.label = 7;
                case 7: return [4 /*yield*/, firebaseInstance.firestore().collection('service_stats')
                        .where('companyId', '==', companyId)
                        .where('serviceId', '==', serviceDocID_1).get()];
                case 8:
                    serviceStatDocRef = _a.sent();
                    if (!serviceStatDocRef.empty) return [3 /*break*/, 12];
                    generateBy = 'manual';
                    expendituresTempl = {
                        2020: {
                            1: [
                                {
                                    amount: 0.01,
                                    date: new Date('2020-01-01'),
                                },
                            ],
                        },
                    };
                    serviceStatSeed = {
                        companyId: companyId,
                        serviceId: serviceDocID_1,
                        expenditures: expendituresTempl,
                        owner: null,
                        companyTeamId: null,
                        generateBy: generateBy,
                    };
                    return [4 /*yield*/, firebaseInstance.firestore().collection('service_stats').add(serviceStatSeed)];
                case 9:
                    docRef = _a.sent();
                    if (!docRef) return [3 /*break*/, 11];
                    setValidationMsg("".concat(selectedService, " is successfully added to your product list"));
                    resetInput();
                    return [4 /*yield*/, (0, backend_1.callBackendFn)('serviceStats-notifyManualAdd')({
                            id: docRef.id,
                            serviceDocID: serviceDocID_1,
                            context: 'ADD_SERVICE_SERVICE_VIEW',
                            companyId: companyId,
                        })];
                case 10:
                    _a.sent();
                    _a.label = 11;
                case 11: return [3 /*break*/, 13];
                case 12:
                    setValidationMsg("".concat(selectedService, " is already in your product list"));
                    resetInput();
                    _a.label = 13;
                case 13: return [3 /*break*/, 15];
                case 14:
                    setValidationMsg('No product specified');
                    resetInput();
                    _a.label = 15;
                case 15: return [2 /*return*/];
            }
        });
    }); };
    if (!allServices) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ServiceNameSelect_1.default, { isLoading: isLoading, handleAddService: saveServiceStat }), validationMsg && (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: validationMsg })), isLoading && (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: "caption" }, { children: [(0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {}), " Saving"] }))] }));
};
exports.default = AddService;
